import React, { Component } from 'react'
import '../styles/SitesListView.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APISiteRequest from '../api/APISiteRequest'
import APIGenericRequest from '../api/APIGenericRequest'
import DatePicker from '../widgets/DatePicker'

class SitesListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user:  JSON.parse(sessionStorage.getItem("user")),
		}
		this.viewDetails = this.viewDetails.bind(this)
		this.createSite = this.createSite.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails("view-details", id, name)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		console.log(this.state.user)
		switch(this.state.user.role_id) {
			case 3: case 7:
				var sites = APISiteRequest.getAllSitesByProvinceId(this.state.accessToken, this.state.user.province_id)
				sites.then((response) => {
					console.log(response)
					if(response.status === "FAILED") {
						this.setState({showActivityIndicator: false})
						return
					}
					const list = response.results.rows
					list.sort((a, b) => {
						return(a.name.localeCompare(b.name))
					})
					this.setState({sites: list, showActivityIndicator: false})
				})
				break
			case 4:
				break
			case 5:
				break
			case 8:
				sites = APISiteRequest.getAllSites(this.state.accessToken)
				sites.then((response) => {
					console.log(response)
					if(response.status === "FAILED") {
						this.setState({showActivityIndicator: false})
						return
					}
					const list = response.results.rows
					list.sort((a, b) => {
						return(a.name.localeCompare(b.name))
					})
	
					this.setState({sites: list, showActivityIndicator: false})
				})
				break
			case 2:
				break
			case 1:
		}
	}

	createSite() {
		this.props.createSite("create-site")
	}

	render() {
		return(<div id="sites-listview">
			{/* <div id="sl-search"><SearchSites /></div> */}
			<div id="sl-listview"><ListView data={this.state.sites} roleId={this.state.user.role_id}
				createSite={this.createSite}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

class SearchSites extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user:  JSON.parse(sessionStorage.getItem("user")),
		}
	}

	componentWillMount() {
		const sites = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, this.state.user.province_id)
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push(v.name)

			}
			c.sort()
			const cities = []
			for(const v of c) {
				cities.push({name: v})
			}
			this.setState({cities: cities})
		})
	}

	render() {
		const items = []
		return(<div className="search-bar">
			<div>SEARCH BY</div>
			<br/>
			<div>Municipality/City</div>
			<DropdownWidget placeholder="ANY" list={this.state.cities} onItemSelected={(e) => {console.log(e)}} />
			<br/>
			<div>Date Added</div>
			<DropdownWidget placeholder="CUSTOM" list={items} cStyle={{'min-width': '100%'}} onItemSelected={(e) => {console.log(e)}} />
			<div className="sb-date"><div className="sb-date-lbl">From</div>
				<div className="sb-date-cl"><DatePicker name="from" /></div>
			</div>
			<div className="sb-date"><div className="sb-date-lbl" style={{'text-align': 'right'}}>To</div>
				<div><DatePicker name="to" /></div>
			</div>
			<br/><br/>
			<button className="green-two">SEARCH</button>
			<button className="green-two" onClick={(e) => {
			}}>CLEAR</button>		</div>)
	}
}

class ListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.length + " SITE(s)": "0 SITE",
			listItems: [],
			createSite: props.createSite,
			roleId: props.roleId
		}
		this.viewDetails = this.viewDetails.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails(id, name)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			const listItems = []
			if(this.props.data == null) {
				return
			}
			if(this.props.data.length <= 0) {
				return
			}
			for(const v of this.props.data) {
				listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " SITE(S)": "0 SITE",
				listItems: listItems
			})
		}
	}

	render() {
		return(<div className="site-lv">
			<div className="flv-top">
				<InputSearchWidget placeholder="SEARCH" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " SITE(S)",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " SITE(S)",
							listItems: listItems
						})
					}} />
				<div className="flv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="flv-header">
				<table className="flv-table-header">
					<col style={{width: '34%'}} />
					<col style={{width: '33%'}} />
					<col style={{width: '33%'}} />
					<tr>
						<th>SITE NAME</th>
						<th>PROVINCE</th>
						<th>MUNICIPALITY</th>
						<div className="slv-grid-btn">
							{this.state.roleId != 8 && <div></div>}
							{this.state.roleId == 8 && <button className="green-two" onClick={(e) => {
								this.state.createSite()
							}}>ADD SITE</button>}
						</div>
					</tr>
				</table>
			</div>
			<div className="flv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="flv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	console.log(props)
	return(<div className="fc-list-item">
			<table className="fc-table-data">
				<col style={{width: '34%'}} />
				<col style={{width: '33%'}} />
				<col style={{width: '33%'}} />
				<tr>
					<td>{props.data.name.toUpperCase()}</td>
					<td>{props.data.province}</td>
					<td>{props.data.city}</td>
					<div className="flv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.site_id, props.data.name)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const searchString = (str, data) => {
	console.log("searchString")
	console.log(data)
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const list = []
	for(const v of data) {
		const name = v.name
		if(name.toLowerCase().includes(str.toLowerCase()) || v.city.toLowerCase().includes(str.toLowerCase()) || v.province.toLowerCase().includes(str.toLowerCase())) {
			list.push(v)
		}
	}
	return(list)
}

export default SitesListView
